var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiHomeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.45292L16.7917 9.76542V17.25H14.875V11.5H9.12502V17.25H7.20835V9.76542L12 5.45292ZM12 2.875L2.41669 11.5H5.29169V19.1667H11.0417V13.4167H12.9584V19.1667H18.7084V11.5H21.5834",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiHomeOutline);
export default __webpack_public_path__ + "static/media/mdi_home-outline.a04896f234781d2e415e6befd4375494.svg";
export { ForwardRef as ReactComponent };